import React from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import { AppWrap } from '../../wrapper';

import './Header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const Header = () => {
  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        <motion.div
          whileInView={{ y: [100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
          className="app__header-info"
        >
          <div className="app__header-badge items-start ">
            <div className="badge-cmp app__flex">
              <div>
                <p className="p-text tag ml-[-3rem]">Hi, I Am </p>
                <h1 className="head-text text-left">Umesh Sharma.</h1>
              </div>
            </div>
            <div className="tag-cmp app-flex">
              <p className=" mt-5 ">
                I build web products that perform, for businesses that need
                results, and teams that need a developer they can rely on{' '}
                <span className="dot">.</span>
              </p>
            </div>
            <div
              className="flex items-start justify-start 
  min-md:gap-10 gap-10  transition-all duration-300 "
            >
              <button className="btn hover:text-black  hover:bg-white/50 text-white  w-auto px-5 font-semibold max-lg:text-sm max-sm:text-[9px]">
                <a href={`#contact`}>Need a Dev</a>
              </button>
              <button className="btn  text-white bg-white/20 hover:bg-transparent w-auto px-5 font-semibold  max-sm:text-[9px]">
                <a href={`#work`}>See My Projects</a>
              </button>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="hero-pattern "
          whileInView={{ x: [60, 0], opacity: [0, 1], delayChildren: 1.8 }}
        >
          <img
            src={images.hero}
            alt="development"
            className="pattern-rotate hover:scale-105 transition-all duration-500 ease-in-out"
          />
        </motion.div>

        {/* <motion.img
          whileInView={{ opacity: [0, 1] }}
          transition={{ duration: 0.5, delayChildren: 0.5 }}
          src={images.circle}
          alt="profile_circle"
          className="overlay_circle"
        /> */}
      </motion.div>
    </div>
  );
};

export default AppWrap(Header, 'home');
